import { APIResponseStatus } from 'Services/api.types';

import { useServiceFeeEnabled } from 'Components/transactionFees/hooks/useServiceFeeEnabled';
import { useServiceFeeNotice } from 'Components/transactionFees/hooks/useServiceFeeNotice';

import { useSaleDetailsSub } from '../../hooks/useSaleDetailsSub';
import { useVehicleCollectionSub } from '../../hooks/useVehicleCollectionSub';

import { type SaleDetailsContentViewProps, SaleDetailsContentView } from './components/SaleDetailsContentView/SaleDetailsContentView';
import { SaleDetailsContentProps } from './SaleDetails.types';

export const useSaleDetailsContent = ({
  showDetailsItems, title, titleIcon, variant,
}: SaleDetailsContentProps): SaleDetailsContentViewProps => {
  const { isSaleComplete } = useVehicleCollectionSub();

  const {
    enquiryId,
    financingAmount,
    hasNegativeEquity,
    neBankTransferTotalAmount,
    offerStatus,
    sellerAmount,
    serviceFee,
    soldForFigure,
    vehicleThumbnail,
    vrm,
  } = useSaleDetailsSub();

  const { isServiceFeeEnabled } = useServiceFeeEnabled();
  const serviceFeeNoticeProps = useServiceFeeNotice({
    enquiryId, serviceFee, soldForFigure: soldForFigure ?? null, vrm,
  });

  const {
    showHomeCollectionLineItem = true,
    showPayoutDetails = false,
  } = showDetailsItems ?? {};

  return {
    bankTransferFigure: neBankTransferTotalAmount,
    financeFigure: financingAmount,
    isServiceFeeEnabled,
    mode: (() => {
      if (isSaleComplete) {
        return 'saleComplete';
      }

      if (hasNegativeEquity) {
        return 'negativeEquity';
      }

      return 'positiveEquity';
    })(),
    sellerFigure: sellerAmount,
    serviceFeeNoticeProps,
    showAsError: offerStatus === APIResponseStatus.ERROR,
    showHomeCollectionLineItem,
    showOverpaymentMessage: !isSaleComplete,
    showPayoutDetails,
    showVehicleCard: Boolean(vehicleThumbnail),
    soldForFigure,
    title,
    titleIcon,
    variant,
  };
};

export const SaleDetailsContent = (props: SaleDetailsContentProps) => (
  <SaleDetailsContentView {...useSaleDetailsContent(props)} />
);
